import _ from '@/assets/lib/my-lodash'
const SAVE_KEY_PREFIX = 'format_'
const SAVE_INTERVAL_MS = 1000

export default {
  data: function () {
    return {
      saveName: '',
      saveKeyPrefix: SAVE_KEY_PREFIX,
      dataChangedEmitKey: 'format-data-changed',
      formatData: {},
      isNowSaving: false,
      changeCount: 0
    }
  },
  computed: {
    saveKey: function () {
      if (!this.saveName) {
        return
      }
      return this.saveKeyPrefix + this.saveName
    }
  },
  methods: {
    saveFormatData: _.debounce(
      function () {
        const app = this
        if (!this.saveKey) {
          console.error('this.saveName is required')
          return
        }
        this.$setItem(this.saveKey, this.formatData,
          function (err) {
            if (err) {
              console.log(err)
              app.isNowSaving = false
              return
            }
            // console.log('saved:', app.formatData)
            app.isNowSaving = false
            app.$eventHub.$emit('save-complete-notify', 'おぼえた')
            app.$eventHub.$emit('yagi-message', 'おぼえた')
          })
      },
      // ユーザーの入力が終わるのを待つ時間をミリ秒で指定します。
      SAVE_INTERVAL_MS
    ),
    loadFormatData: function () {
      const app = this
      this.$getItem(this.saveKey,
        function (err, data) {
          if (err) {
            console.log(err)
            return
          }
          if (data == null || typeof data === 'undefined') {
            return
          }
          app.formatData = data
          // 読み込み完了後にプレビューの高さ計算する用
          app.$nextTick(() => {
            app.$eventHub.$emit('local-format-data-loaded', app.saveName)
          })
          // 読み込み直後の再保存を防ぐ
          app.changeCount = 0
        }
      )
    },
    updateFormatData: function (newData) {
      for (var nd in newData) {
        if (this.formatData.hasOwnProperty(nd)) {
          this.$set(this.formatData, nd, newData[nd])
        } else {
          console.log('not hasOwnProperty:', nd)
        }
      }
    },
    setDefaultFormatData: function () {}
  },
  watch: {
    'formatData': {
      deep: true,
      handler: function (val) {
        this.$eventHub.$emit(this.dataChangedEmitKey, val)
        this.changeCount++
      },
      immediate: false
    },
    'changeCount': function () {
      if (!this.$yagi.profile.autoSaveEnabled) {
        console.log('saveFormatData() skipped autoSaveEnabled is false', this.$yagi.profile.autoSaveEnabled)
        return
      }
      /* 初回ロード完了時に保存が走ってしまうのでスキップ */
      if (this.changeCount < 2) {
        return
      }
      if (!this.isNowSaving) {
        this.saveFormatData()
      } else {
        console.log('skip saveFormatData', this.isNowSaving)
      }
    }
  },
  beforeMount: function () {
    this.setDefaultFormatData()
    this.loadFormatData()
    this.$eventHub.$on('backup-loaded-' + this.saveKey, this.loadFormatData)
  },
  destroyed: function () {
    this.$eventHub.$off('backup-loaded-' + this.saveKey)
  }
}
